import { loadingSpinnerSvg } from '../../loading-spinner/loading-spinner.js'

export function setLoadingState(isLoading) {
  const translationReport = document.querySelector('.Translation-Report')
  if (!translationReport) {
    return
  }

  let overlay = translationReport.querySelector('.Translation-Report__overlay')

  if (!overlay) {
    overlay = document.createElement('div')
    overlay.className = 'Translation-Report__overlay'
    overlay.innerHTML = loadingSpinnerSvg
    translationReport.appendChild(overlay)
  }

  if (isLoading) {
    overlay.classList.add('Translation-Report__overlay--visible')
  } else {
    overlay.classList.remove('Translation-Report__overlay--visible')
  }
}
